import { CHANGE_STEP } from '../action-types';

export const initialState = {
  currentStep: 0
};

export const stepsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CHANGE_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };

    default:
      return state;
  }
};
